/** HIT-Bewegung bereit zum Melden bzw. gerade beim Versand. */
export const HIT_STATUS_BEREIT = 141;
export const HIT_STATUS_SELEKTIERT = 144;
export const HIT_STATUS_GEMELDET = 142;
export const HIT_STATUS_FEHLERHAFT = 143;
export const HIT_STATUS_BEREITS_GEMELDET = 145;
export const HIT_STATUS_ENTWURF = 140;

export const HIT_DATUM_GESPERRT_TEXT =
    'Die HIT-Meldung läuft noch. Das Datum kann erst geändert werden, wenn die Meldung bestätigt oder als fehlerhaft zurückgekommen ist.';

export const HIT_LISTE_WIEDER_OEFFNEN_FEHLER = 'Die Tierliste konnte nicht wieder geöffnet werden.';

export function istHitMeldungLaufend(statusId?: number | null): boolean {
    return statusId === HIT_STATUS_BEREIT || statusId === HIT_STATUS_SELEKTIERT;
}

export function hatLaufendeHitMeldung(
    tiere: Array<{ status_id_einstallen?: number | null; status_id_abgang?: number | null }> | null | undefined,
    art: 'einstallen' | 'abgang',
): boolean {
    if (!tiere?.length) {
        return false;
    }
    return tiere.some(t =>
        istHitMeldungLaufend(art === 'einstallen' ? t.status_id_einstallen : t.status_id_abgang),
    );
}
